// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"73a84232","432":"88af708a"}[chunkId] + ".chunk.css";
};